module.exports = __webpack_public_path__ + "media/images/icons/filled/down-circle-841fe9f9ef2095127c030b468d2a4955.svg";